import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';
import { lookupErrorMessage } from './error.map';
import { NormalizedGQLError } from '@/common/services/error/types';
import { GqlOperationPathEnum } from '@/common/enums/gql-operation-path.enum';

export function normalizeApolloError(err: unknown): NormalizedGQLError {
  const isGraphQLError = CombinedGraphQLErrors.is(err);
  const isServerError = ServerError.is(err);
  const g = isGraphQLError ? err.errors?.[0] : undefined;
  const ext = (g?.extensions ?? {}) as {
    code?: string;
    originalError?: { statusCode?: number };
    serviceName?: string;
  };

  const code = ext.code as string | undefined;
  const statusCode =
    ext.originalError?.statusCode ??
    (isServerError ? err.statusCode : undefined);
  const serviceName = ext.serviceName as string | undefined;
  const path = Array.isArray(g?.path)
    ? (g?.path[0] as GqlOperationPathEnum)
    : undefined;
  const raw =
    g?.message ?? (err instanceof Error ? err.message : 'Unknown error');

  const norm: NormalizedGQLError = {
    code,
    statusCode,
    serviceName,
    path,
    message: '',
  };
  norm.message = lookupErrorMessage(norm, raw);

  return norm;
}
